import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, Typography, Divider } from "antd";
import {
  TeamOutlined,
  ShoppingOutlined,
  BarChartOutlined,
  ProfileOutlined,
  IdcardOutlined,
  BellOutlined,
  AuditOutlined,
  AppstoreOutlined,
  FileTextOutlined,
  SettingOutlined,
} from "@ant-design/icons";

const { Text } = Typography;

const SidebarNavLink = ({ to, icon, children }) => {
  const location = useLocation();
  const isActive = location.pathname === to;

  return (
    <Menu.Item key={to} icon={icon} className={isActive ? 'ant-menu-item-selected' : ''}>
      <Link to={to}>{children}</Link>
    </Menu.Item>
  );
};

const SidebarMenu = () => {
  const location = useLocation();
  const token = localStorage.getItem("token");
  const userType = localStorage.getItem("userType");

  if (!token) return null;

  return (
    <div className="sidebar-container">
      <div className="logo-container">
        <img src="/img/icon-512-maskable.png" width={40} height={40} alt="Logo" className="logo-icon" />
        <Text className="logo-text">Siparify</Text>
      </div>

      <Divider className="sidebar-divider" />

      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[location.pathname]}
        className="sidebar-menu"
      >
        {userType === "ADMIN" && (
          <>
            <Menu.ItemGroup key="admin" title="Yönetim">
              <SidebarNavLink to="/admin/dashboard" icon={<BarChartOutlined />}>
                Panel
              </SidebarNavLink>
              <SidebarNavLink to="/admin/customers" icon={<TeamOutlined />}>
                Müşteriler
              </SidebarNavLink>
              <SidebarNavLink to="/admin/employees" icon={<TeamOutlined />}>
                Çalışanlar
              </SidebarNavLink>
              <SidebarNavLink to="/admin/owner-card" icon={<IdcardOutlined />}>
                Kartvizit
              </SidebarNavLink>
            </Menu.ItemGroup>

            <Menu.ItemGroup key="orders" title="Sipariş Yönetimi">
              <SidebarNavLink to="/admin/orders" icon={<ShoppingOutlined />}>
                Siparişler
              </SidebarNavLink>
              <SidebarNavLink to="/admin/invoices" icon={<FileTextOutlined />}>
                Faturalar
              </SidebarNavLink>
              <SidebarNavLink to="/admin/products" icon={<AppstoreOutlined />}>
                Ürün Envanteri
              </SidebarNavLink>
            </Menu.ItemGroup>

            <Menu.ItemGroup key="system" title="Sistem">
              <SidebarNavLink to="/admin/audit-logs" icon={<AuditOutlined />}>
                Denetim Kayıtları
              </SidebarNavLink>
              <SidebarNavLink to="/admin/invoice-settings" icon={<SettingOutlined />}>
                Fatura Ayarları
              </SidebarNavLink>
              <SidebarNavLink to="/settings/notifications" icon={<BellOutlined />}>
                Bildirim Tercihleri
              </SidebarNavLink>
            </Menu.ItemGroup>
          </>
        )}

        {userType === "CUSTOMER" && (
          <>
            <Menu.ItemGroup key="customer" title="Müşteri Paneli">
              <SidebarNavLink to="/orders" icon={<ShoppingOutlined />}>
                Siparişlerim
              </SidebarNavLink>
              <SidebarNavLink to="/invoices" icon={<FileTextOutlined />}>
                Faturalarım
              </SidebarNavLink>
            </Menu.ItemGroup>

            <Menu.ItemGroup key="settings" title="Ayarlar">
              <SidebarNavLink to="/settings/notifications" icon={<BellOutlined />}>
                Bildirim Tercihleri
              </SidebarNavLink>
            </Menu.ItemGroup>
          </>
        )}

        {userType === "EMPLOYEE" && (
          <>
            <Menu.ItemGroup key="employee" title="Çalışan Paneli">
              <SidebarNavLink to="/employee/order-items" icon={<ProfileOutlined />}>
                İşlerim
              </SidebarNavLink>
            </Menu.ItemGroup>

            <Menu.ItemGroup key="settings" title="Ayarlar">
              <SidebarNavLink to="/settings/notifications" icon={<BellOutlined />}>
                Bildirim Tercihleri
              </SidebarNavLink>
            </Menu.ItemGroup>
          </>
        )}
      </Menu>

      <div className="sidebar-footer">
        <Text className="version-text">v1.0.0</Text>
      </div>
    </div>
  );
};

export default SidebarMenu;
